import { render, staticRenderFns } from "./AccordionTransition.vue?vue&type=template&id=2eaf0d32"
import script from "./AccordionTransition.vue?vue&type=script&lang=js"
export * from "./AccordionTransition.vue?vue&type=script&lang=js"
import style0 from "./AccordionTransition.vue?vue&type=style&index=0&id=2eaf0d32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports